export const API_EXTERNAL_ENDPOINT = 'stats/cottage/new-multi'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/stats/cottage/new-multi'
